import React, { useEffect, useState } from "react";
import { Badge, Card, CardBody, CardHeader, Collapse } from "reactstrap";
import { Btn, H3, H4, P } from "../../../../AbstractElements";

import { useNavigate } from "react-router";
import { showAsesorContactsApi } from "../../Api/ShowContact";
import { getErrorsArrayMessageFromHtttpResponse } from "../../../../Shared/Utils/errorUtils";

export default function ContactData({
  item,
  personalData,
  contactData,
  socialData,
  asesors,
  contactEntities,
}) {
  //context

  const [contactsAsesored, setcontactsAsesored] = useState([]);
  const handleEntityClick = (entity) => {
    setFilters({
      ...filters,
      ...{ entity_id: entity?.id },
    });
    navigate(`${process.env.PUBLIC_URL}/app/contacts`);
  };
  const API_URL = process.env.REACT_APP_API_URL;
  const routeImage = `${API_URL}${process.env.REACT_APP_API_URL_AVATAR}`
  const getInitials = () => {
    return `${item?.first_name[0]}${item?.last_name[0]}`;
  };
  const navigate = useNavigate();
  const handleViewAsesor = (row) => {
    navigate(`${process.env.PUBLIC_URL}/app/contacts/detail/${row.id}`);
  };

  //lista los contactos a los que un asesor le brinda aseosria
  const getAsesorContacts = async (id) => {
    let response = await showAsesorContactsApi(id);

    if (response?.result && response?.result == "success") {
      setcontactsAsesored(
        response.data.map((contact) => ({
          ...contact,
          name: `${contact.first_name} ${contact.last_name}`,
        }))
      ); // Actualizar el estado con un nuevo array transformado
    } else {
      console.log(getErrorsArrayMessageFromHtttpResponse(response));
    }
  };

  useEffect(() => {
    if (item?.charge?.name == "ASESOR") {
      getAsesorContacts(item?.id);
    }
  }, [item]);

  console.log(item);


  return (
    <Card className="p-5">
      <div className="text-center">
        <a
          href={`${process.env.PUBLIC_URL}/app/contacts/edit/${item?.id}`}
          className="position-absolute top-0 end-0 p-3"
        >
          <i className="fa fa-pencil" aria-hidden="true"></i>
        </a>
        <div className="d-flex align-items-center justify-content-center">
          <div className="media-body flex-grow-2 mt-0 ">
            {!item.avatar_url ? (<div
              className="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3"
              style={{
                width: "80px",
                height: "80px",
                backgroundColor: "#ccc",
                fontSize: "32px",
                color: "#fff",
              }}
            >
              {getInitials()}
            </div>) : (<div >
              <img className="rounded-circle w" src={`${routeImage}/${item.avatar_url}`} alt=""
                style={{
                  width: "80px",
                  height: "80px",
                  marginBottom: "1rem"

                }} />
            </div>)}

            <H3>
              <span className="first_name_5">
                {item.first_name} {item.last_name}
              </span>
            </H3>
            <P attrPara={{ className: "email_add_5" }}>{item.charge?.name}</P>
          </div>
        </div>




      </div>
      <div className="profile-mail">
        <div className="email-general text-left">
          <div className="gender">
            <H4>Datos personales</H4>

            <P>
              Jurisdicccion: <span>{personalData?.jurisdiction?.name}</span>
            </P>
            <P>
              Espacio politico: <span>{personalData?.politic_space?.name}</span>
            </P>
            <P>
              Distrito: <span>{personalData?.district?.name}</span>
            </P>
            <P>
              Bloque: <span>{personalData?.block?.name}</span>
            </P>

            <P>
              Fecha inicio: <span>{personalData?.charge_start_at}</span>
            </P>

            <P>
              Fecha fin: <span>{personalData?.charge_end_at}</span>
            </P>
            <P>
              Url de perfil:
              <span style={{ wordBreak: "break-all" }}>
                <a target="_blank" href={personalData?.profile_url}>
                  {personalData?.profile_url}
                </a>
              </span>
            </P>
          </div>
        </div>
        <div className="email-general text-left">
          <H4>Datos de contacto</H4>
          <P>
            Email 1:
            <span className="font-primary email_add_5">
              {contactData?.email_1}
            </span>
          </P>
          <P>
            Whatsapp 1:
            <span className="font-primary email_add_5">
              {contactData?.whatsapp_1}
            </span>
          </P>
          <P>
            Email 2:{" "}
            <span className="font-primary email_add_5">
              {contactData?.email_2}
            </span>
          </P>
          <P>
            Whatsapp 2:
            <span className="font-primary email_add_5">
              {contactData?.whatsapp_2}
            </span>
          </P>
          <P>
            Email 3:
            <span className="font-primary email_add_5">
              {contactData?.email_3}
            </span>
          </P>
          <P>
            Whatsapp 3:
            <span className="font-primary email_add_5">
              {contactData?.whatsapp_3}
            </span>
          </P>
        </div>
        <div className="email-general text-left">
          <div className="gender">
            <H4>Redes sociales</H4>

            <P>
              Facebook:
              <span style={{ wordBreak: "break-all" }}>
                <a target="_blank" href={socialData?.facebook_url}>
                  {socialData?.facebook_url}
                </a>
              </span>
            </P>
            <P>
              Sitio Web:
              <span style={{ wordBreak: "break-all" }}>
                <a target="_blank" href={socialData?.website_url}>
                  {socialData?.website_url}
                </a>
              </span>
            </P>
            <P>
              Instagram:
              <span style={{ wordBreak: "break-all" }}>
                <a target="_blank" href={socialData?.instagram_url}>
                  {socialData?.instagram_url}
                </a>
              </span>
            </P>
            <P>
              Instagram Usuario: <span>{socialData?.instagram_username}</span>
            </P>
            <P>
              Twitter:
              <span style={{ wordBreak: "break-all" }}>
                <a target="_blank" href={socialData?.twitter_url}>
                  {socialData?.twitter_url}
                </a>
              </span>
            </P>
            <P>
              Twitter Usuario: <span>{socialData?.twitter_username}</span>
            </P>

            <P>
              LinkedIn:
              <span style={{ wordBreak: "break-all" }}>
                <a href={socialData?.linkedin_url}>
                  {socialData?.linkedin_url}
                </a>
              </span>
            </P>
          </div>
        </div>

        {item?.charge?.name == "PERIODISTA" ? (
          <div className="email-general">
            <div className="gender">
              <H4>Entidades</H4>

              {contactEntities.length > 0 &&
                contactEntities.map((entity) => (
                  <a href="#" onClick={() => handleEntityClick(entity)}>
                    <Badge color="primary">{entity.name}</Badge>
                  </a>
                ))}
            </div>
          </div>
        ) : null}

        {item?.charge?.name == "DIPUTADO" || item?.charge?.name == "SENADOR" ? (
          <div className="email-general">
            <div className="gender">
              <H4>Comission</H4>

              {item?.comissions?.length > 0 &&
                item?.comissions.map((comission) => (
                  <Badge color="primary">{comission.name}</Badge>
                ))}
            </div>
          </div>
        ) : null}
        {item?.charge?.name != "ASESOR" ? (
          <div className="email-general">
            <div className="gender">
              <H4>Asesores</H4>

              <div>
                {asesors?.map((item, index) => (
                  <Card>
                    <CardHeader key={index + 1}>
                      <H3 attrH3={{ className: "mb-0" }}>
                        <Btn
                          attrBtn={{
                            as: Card.Header,
                            className: "ps-0 btn btn-link",
                            color: "default",
                            onClick: () => handleViewAsesor(item),
                          }}
                        >
                          {item.first_name} {item.last_name}
                        </Btn>
                      </H3>
                    </CardHeader>
                  </Card>
                ))}
              </div>
            </div>
          </div>
        ) : null}
        {item?.charge?.name == "ASESOR" ? (
          <div className="email-general">
            <div className="gender">
              <H4>Contactos que asesora</H4>

              <div>
                {contactsAsesored?.map((item, index) => (
                  <Card>
                    <CardHeader key={index + 1}>
                      <H3 attrH3={{ className: "mb-0" }}>
                        <Btn
                          attrBtn={{
                            as: Card.Header,
                            className: "ps-0 btn btn-link",
                            color: "default",
                            onClick: () => handleViewAsesor(item),
                          }}
                        >
                          {item.first_name} {item.last_name}
                        </Btn>
                      </H3>
                    </CardHeader>
                  </Card>
                ))}
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </Card>
  );
}
